//====================================================
//  Function: Category Create
//====================================================
var categoryGroup = $('.js-category-group')

function componentCategoryCreate() {
  if ($('.js-category-group').length) {
    categoryGroup = $('.js-category-group')

    addToCategoryResultCode()
    rebuildTopCategoryResult()

    $('.js-select-option').change(function () {
      var checkbox = $(this)
      // var checkboxValue = checkbox.val()
      // var checkboxCode = checkbox.closest('.js-select-item').data('code')
      $('div').removeClass('is-clicked')
      $('.code-box__item').removeClass('is-clicked')
      // clearTimeout(myTimeoutCode);
      addToCategoryResultCode()
      rebuildTopCategoryResult()
    })

    $(document).on(
      'keyup',
      '.js-select-input, .js-select-input-main, .js-select-input-another, .js-category-input',
      function () {
        addToCategoryResultCode()
        rebuildTopCategoryResult()
      },
    )

    $(document).on(
      'change',
      '.js-block-item-css .js-select-input',
      function () {
        addToCategoryResultCode()
        rebuildTopCategoryResult()
      },
    )
  }
}

function addToCategoryResultCode() {
  var arrayResultCategory = []
  var arrayResultCategoryCSS = []
  var arrayResultCategoryItems = []
  var arrayResultTextItems = []
  var arrayResultEmptyTextItems = []
  var arrayResultBtnItems = []
  var arrayResultPhoneItems = []
  var arrayResultMobileItems = []
  var arrayResultEmailItems = []
  var arrayResultSideCategory = []
  var mainItem = false
  var anotherItemText = true
  var anotherItemSubtext = true
  var anotherItemBtn = true

  var index = $('.js-select-item')
  index.find('.js-block-item').each(function () {
    var item = $(this)
    var blockItemCSS = item.hasClass('js-block-item-css')
    if (item.data('comment') !== undefined) {
      if (item.data('comment').length) {
        if (blockItemCSS) {
          arrayResultCategoryCSS.push(
            "<div class='code__comment'>/* " +
              item.data('comment') +
              '*/</div>',
          )
        } else {
          arrayResultCategory.push(
            "<div class='code__comment'>// " + item.data('comment') + '</div>',
          )
        }
      }
    }

    item.find('.js-json-input').each(function () {
      input = $(this)
      var dataJson = input.attr('data-json')
      var dataVar = input.attr('data-var')
      if (input.val().length > 0) {
        var inputValue = input.val()
        if (dataVar === 'registrationDiscountAddonTitleLang') {
          arrayResultTextItems.push(`${dataJson}:"${inputValue}"`)
        }

        // if (dataVar === 'registrationDiscountAddonTextEmptyLang') {
        //   arrayResultEmptyTextItems.push(`${dataJson}:"${inputValue}"`)
        // }

        if (dataVar === 'registrationDiscountAddonTextBtnLang') {
          arrayResultBtnItems.push(`${dataJson}:"${inputValue}"`)
        }
      }
    })

    if (anotherItemText) {
      if (arrayResultTextItems.join().length > 0) {
        var templateBoxItem = `
					<div class="code-box__item">
					<strong>var <span class="js-result-type">registrationDiscountAddonTitleLang</span> = <span class="js-result-value txt-green">{${arrayResultTextItems.join()}};</span></strong></div>
				`
        arrayResultCategory.push(templateBoxItem)
        anotherItemText = false
      }
    }

    // if (anotherItemSubtext) {
    //   if (arrayResultEmptyTextItems.join().length > 0) {
    //     var templateBoxItem = `
    // 			<div class="code-box__item">
    // 			<strong>var <span class="js-result-type">registrationDiscountAddonTextEmptyLang</span> = <span class="js-result-value txt-green">{${arrayResultEmptyTextItems.join()}};</span></strong></div>
    // 		`
    //     arrayResultCategory.push(templateBoxItem)
    //     anotherItemSubtext = false
    //   }
    // }

    if (anotherItemBtn) {
      if (arrayResultBtnItems.join().length > 0) {
        var templateBoxItem = `
					<div class="code-box__item">
					<strong>var <span class="js-result-type">registrationDiscountAddonTextBtnLang</span> = <span class="js-result-value txt-green">{${arrayResultBtnItems.join()}};</span></strong></div>
				`
        arrayResultCategory.push(templateBoxItem)
        anotherItemBtn = false
      }
    }

    item.find('.js-select-input').each(function () {
      var input = $(this)
      var inputParent = input.closest('.js-stats')
      var inputValue = input.val()
      var inputCode = inputParent.data('code')
      var inputQuotes = inputParent.data('quotes')
      var inputPX = inputParent.data('px')
      var inputDivider = inputParent.data('divider')
      var inputType = inputParent.data('type')

      if (inputDivider == true) {
        inputValue = '/' + inputValue
      }

      if (blockItemCSS) {
        inputValue = '' + inputValue + ''
      } else {
        if (inputQuotes == true) {
          inputValue = '"' + inputValue + '"'
        }

        if (inputPX == true) {
          inputValue = inputValue + 'px'
        }

        if (inputType == 'number') {
          inputValue = parseInt(inputValue)
        } else {
          inputValue = '"' + inputValue + '"'
        }
      }

      // var templateBoxItem = `
      // 		<div class="code-box__item">
      // 		<strong>var <span class="js-result-type">${inputCode}</span> = <span class="js-result-value txt-green">${inputValue};</span></strong></div>
      // `
      if (input.hasClass('js-json-input')) {
      } else {
        if (blockItemCSS) {
          var templateBoxItem = `
						<div class="code-box__item">
						<strong>--<span class="js-result-type">${inputCode}</span>: <span class="js-result-value txt-green">${inputValue};</span></strong></div>
					`
          arrayResultCategoryCSS.push(templateBoxItem)
          inputParent
            .find('.js-label-value')
            .html('--' + inputCode + ' = <span> ' + inputValue + '</span>')
        } else {
          var templateBoxItem = `
						<div class="code-box__item">
						<strong>var <span class="js-result-type">${inputCode}</span> = <span class="js-result-value txt-green">${inputValue};</span></strong></div>
					`
          arrayResultCategory.push(templateBoxItem)
          arrayResultSideCategory.push(templateBoxItem)
          inputParent
            .find('.js-label-value')
            .html('var ' + inputCode + ' = <span> ' + inputValue + '</span>')
        }
      }
    })

    item.find('.js-stats-checkbox').each(function () {
      var element = $(this)
      var checkedCheckbox = element.find('.js-select-option')
      var checkboxValue = checkedCheckbox.val()
      var clickedClass = ''
      var checkboxCode = element.data('code')
      var checkboxQuotes = element.data('quotes')

      if (checkedCheckbox.is(':checked')) {
        checkboxValue = true
      } else {
        checkboxValue = false
      }

      if (checkboxQuotes == true) {
        checkboxValue = '"' + checkboxValue + '"'
      }

      if (element.hasClass('is-clicked')) {
        clickedClass = 'is-clicked'
      }

      if (element.attr('data-type') === 'option') {
        checkboxValue = `"${element.find('select').val()}"`
      }

      // if (checkboxValue === 'false' || checkboxValue === '"left"') {
      //   return false
      // }

      var templateBoxItem = `
			<div class="code-box__item ${clickedClass}">
			<strong>var <span class="js-result-type">${checkboxCode}</span> = <span class="js-result-value txt-green">${checkboxValue};</span></strong></div>
			`
      arrayResultCategory.push(templateBoxItem)
      arrayResultSideCategory.push(templateBoxItem)
      element
        .find('.js-label-value')
        .html('var ' + checkboxCode + ' = <span> ' + checkboxValue + '</span>')
    })

    if (item.hasClass('line-break')) {
      arrayResultCategory.push('<br>')
      // arrayResultSide.push('<br>')
    }
  })

  $('.js-code-result').empty()
  $('.js-code-result--side').empty()
  $('.js-code-result--subcategory').empty()
  $('.js-code-result--css').empty()
  $('.js-code-result').append(arrayResultCategory)
  $('.js-code-result--side').append(arrayResultSideCategory)
  $('.js-code-result--css').append(arrayResultCategoryCSS)
}

var registrationDiscountTemplate
var registrationDiscountRadius = ''
var registrationDiscountBG = ''
var registrationDiscountBorder = ''
var registrationDiscountLines = ''
var registrationDiscountIcon = ''

var registrationDiscountAddonTitle = ''
var registrationDiscountAddonLink = ''

var registrationDiscountTitle = ''
var registrationDiscountLink = ''
var registrationDiscountBtn = ''
var registrationDiscountTextBtn = ''

function rebuildTopCategoryResult() {
  buttonsBlock = $('.result-block')

  registrationDiscountAddon = $('#registration_discount_active').is(':checked')
  registrationDiscountAddonRadius = $('#registration_discount_radius').is(
    ':checked',
  )
  registrationDiscountAddonPercent = $('#registration_discount_percent').val()
  registrationDiscountAddonAll = $('#registration_discount_all_products').val()

  registrationDiscountAddonTitle = $('#registration_discount_title').val()
  registrationDiscountAddonTextBtn = $('#registration_discount_text_btn').val()

  registrationDiscountLink = $('#registration_discount_link').is(':checked')
  registrationDiscountLinkHref = $('#registration_discount_link_url').val()
  registrationDiscountBtnHrefExternal = $(
    '#registration_discount_link_url_external',
  ).is(':checked')

  registrationDiscountAddonBG = $('#registration_discount_bg').is(':checked')
  registrationDiscountAddonBorder = $('#registration_discount_border').is(
    ':checked',
  )

  registrationDiscountAddonLines = $('#registration_discount_lines').is(
    ':checked',
  )
  registrationDiscountAddonBtn = $('#registration_discount_btn').is(':checked')

  // CSS
  let root = document.documentElement

  root.style.setProperty(
    '--registration-discount-border-radius',
    $('#registration_discount_border_radius').val(),
  )

  root.style.setProperty(
    '--registration-discount-BG',
    $('#registration_discount_bgs').val(),
  )

  root.style.setProperty(
    '--registration-discount-BG-hover',
    $('#registration_discount_bg-hover').val(),
  )

  root.style.setProperty(
    '--registration-discount-title-color',
    $('#registration_discount_title_color').val(),
  )

  root.style.setProperty(
    '--registration-discount-price-color',
    $('#registration_discount_price_color').val(),
  )

  root.style.setProperty(
    '--registration-discount-btn-BG',
    $('#registration_discount_btn_bgs').val(),
  )

  root.style.setProperty(
    '--registration-discount-btn-BG-hover',
    $('#registration_discount_btn_bgs-hover').val(),
  )

  root.style.setProperty(
    '--registration-discount-btn-icon-color',
    $('#registration_discount_btn_icon_color').val(),
  )

  root.style.setProperty(
    '--registration-discount-btn-text-color',
    $('#registration_discount_btn_text_color').val(),
  )

  root.style.setProperty(
    '--registration-discount-border-color',
    $('#registration_discount_border_color').val(),
  )

  if (registrationDiscountAddon) {
    $('body').addClass('registration-discount-addon')
    removeButton()
    setRegistrationDiscountText()
    setRegistrationDiscountBtn()
    setRegistrationDiscountDesign()
    createRegistrationDiscount()
  } else {
    $('body').removeClass('registration-discount-addon')
    removeButton()
  }
}

function createRegistrationDiscount() {
  var productNumber = 1000

  var productCalculateResult = Math.round(
    productNumber - (productNumber * registrationDiscountAddonPercent) / 100,
  )

  var productCalculateResult = registrationDiscountFormatNumber(
    productCalculateResult.toString(),
    false,
  )
  registrationDiscountTemplate = `
		<div class="registration-discount-block js-registration-discount-block ${registrationDiscountLines} ${registrationDiscountBorder} ${registrationDiscountRadius} ${registrationDiscountBG}">
			${registrationDiscountBtn}
			<div class="registration-discount__text-block">
				<div class="registration-discount__title">${registrationDiscountTitle}</div>
				<div class="registration-discount__price">${productCalculateResult} €</div>
			</div>
		</div>
	`

  $('.result-block').append($(registrationDiscountTemplate))
}

function setRegistrationDiscountBtn() {
  var svgUser = `
		<svg version="1.1" width="12" height="14" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
				viewBox="0 0 10.3 14.5" style="enable-background:new 0 0 10.3 14.5;" xml:space="preserve">
			<path d="M10.3,14.5h-1v-1.3c0-1.2-1-2.2-2.2-2.2h-4C2,11,1,12,1,13.2v1.3H0v-1.3C0,11.4,1.4,10,3.2,10h4c1.7,0,3.2,1.4,3.2,3.2
				V14.5z"/>
			<path d="M5.2,7C3.2,7,1.7,5.4,1.7,3.5l0,0l0,0l0,0c0-0.9,0.4-1.8,1-2.5s1.5-1,2.5-1c0,0,0,0,0,0c1.9,0,3.5,1.6,3.5,3.5
				C8.7,5.4,7.1,7,5.2,7z M5.2,1C5.2,1,5.2,1,5.2,1C4.5,1,3.9,1.3,3.4,1.7C2.9,2.2,2.7,2.8,2.7,3.5l0,0C2.7,4.9,3.8,6,5.2,6
				c1.4,0,2.5-1.1,2.5-2.5C7.7,2.1,6.5,1,5.2,1z"/>
		</svg>
	`

  if (registrationDiscountAddonBtn) {
    if (registrationDiscountBtnHrefExternal == true) {
      registrationDiscountBtn = `
				<a href="${registrationDiscountLink}" class="registration-discount__btn" target="_blank">${svgUser} <span>${registrationDiscountTextBtn}</span></a>
			`
    } else {
      registrationDiscountBtn = `
				<a href="${registrationDiscountLink}" class="registration-discount__btn">${svgUser} <span>${registrationDiscountTextBtn}</span></a>
			`
    }
  } else {
    registrationDiscountBtn = `
				<a class="registration-discount__btn registration-discount__btn--no-bg">${svgUser}</a>
			`
  }
}

function registrationDiscountFormatNumber(x, withDecimals) {
  if (!withDecimals) {
    x = x.replace(/ /g, '')
    x = x.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
    x = x.split('.')[0].split(',')[0]
  } else {
    x = x.replace(/ /g, '')
    x = x.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
    x = x.replace('.', ',')
  }
  return x
}

// Set design for button in detail
function setRegistrationDiscountDesign() {
  if (registrationDiscountAddonRadius) {
    registrationDiscountRadius = 'has-border-radius'
  } else {
    registrationDiscountRadius = ''
  }

  if (registrationDiscountAddonBG) {
    registrationDiscountBG = 'has-bg'
  } else {
    registrationDiscountBG = ''
  }

  if (registrationDiscountAddonBorder) {
    registrationDiscountBorder = 'has-border'
  } else {
    registrationDiscountBorder = ''
  }

  if (registrationDiscountAddonLines) {
    registrationDiscountLines = 'has-lines'
  } else {
    registrationDiscountLines = ''
  }
}

// Set text for button in detail
function setRegistrationDiscountText() {
  if (registrationDiscountAddonTitle) {
    registrationDiscountTitle = registrationDiscountAddonTitle
  } else {
    registrationDiscountTitle = ''
  }

  if (registrationDiscountLinkHref) {
    registrationDiscountLink = registrationDiscountLinkHref
  } else {
    registrationDiscountLink = ''
  }

  if (registrationDiscountAddonTextBtn) {
    registrationDiscountTextBtn = registrationDiscountAddonTextBtn
  } else {
    registrationDiscountTextBtn = ''
  }
}

function removeButton() {
  $('.result-block > div').remove()
}

// Change color picker
$('.picker-color__item').each(function () {
  var input = $(this)
  var inputColorBlock = input.find('.picker-color__input')
  var inputColor = inputColorBlock.find('input')
  var inputNumber = input.find('.js-select-input')
  var inputName = inputColor.attr('name')
  var inputValue
  inputColor.on('input', function (e) {
    inputValue = e.target.value
    inputNumber.val('#' + e.target.value.substring(1))
  })
  inputColor.change(function (e) {
    inputValue = e.target.value
    inputNumber.val('#' + e.target.value.substring(1))
    inputNumber.trigger('change')
  })

  inputNumber.keyup(function (e) {
    inputValue = e.target.value
    inputColor.val('#' + inputValue)
    // inputColor.trigger('change')
  })
})
